import SimpleButtonDropdown from '@rio-cloud/rio-uikit/SimpleButtonDropdown';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import {
    dataLayerPush,
    GAEventName,
    GAEventTrigger,
    GAFlowName,
} from '../../configuration/googleAnalytics/googleAnalytics';
import { Routing } from '../app/Routing';

export const CreateButtonDropdown = () => {
    const navigate = useNavigate();

    const navigateToPoiCreate = () => {
        navigate(Routing.poiCreate);
    };

    const navigateToGeofenceCreate = () => {
        dataLayerPush({
            trigger: GAEventTrigger.click,
            event: GAEventName.createGeofenceClicked,
            flow_name: GAFlowName.createGeofence,
        });
        navigate(Routing.geofenceCreate);
    };

    const items = [
        {
            value: <FormattedMessage id='intl-msg:fleetmonitor.newPOI' />,
            onSelect: navigateToPoiCreate,
        },
        {
            value: <FormattedMessage id='intl-msg:newGeofence' />,
            onSelect: navigateToGeofenceCreate,
        },
    ];

    return (
        <SimpleButtonDropdown
            bsStyle='primary'
            title={
                <div className='display-flex align-items-center gap-5'>
                    <span className='uikit-icon icon-plus' />
                    <FormattedMessage id='intl-msg:button.createButtonDropdown.label' />
                </div>
            }
            items={items}
        />
    );
};

export default CreateButtonDropdown;
